import {Component, OnInit} from '@angular/core';
import { navItemsMsal, navItemsDB, navItemsCertificadaDB, navItemsMixVentas, navItemsPactia,navItemsReporte } from '../../_nav';
import { environment } from '../../../environments/environment';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../applicationinfraestructure/services/authentication.service';
import { UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { MatDialog } from '@angular/material/dialog';
import { UpdateUserComponent } from '../../views/user/update-user/update-user.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.scss']
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItemsMsal;
  ingresoDB = true;
  nombreUsuario: string;
  paramLogin: string;

  constructor(private msalService: MsalUserService, 
    private activeRoute: ActivatedRoute, 
    private authService: AuthenticationService,
    private userData: UsersData,
    public router: Router,
    public dialog :MatDialog  ) {

   this.obtenerUrlsNavbar();   
  }
  ngOnInit(): void {
    this.getuser()
  }

  getuser(){
    let userlogged : string = sessionStorage.getItem("userEmailLogged"); 
    this.authService.getUsuarioBackend(userlogged).subscribe(
      values => {
        this.userData = values;
        environment.edificiosAutorizados =  values.edificiosAutorizados;
        environment.marcasAutorizadas =  values.marcasAutorizadas;
        environment.tipoUsuario = values.tipoUsuario;
        environment.userSubscripciónId=values.subscripciónId;
        environment.userEmailLogged = values.email
        this.nombreUsuario = `${values.nombre} ${values.apellido}` ;
      },
      (error) => {
        console.log("Error: " + error);
        //alert('El usuario logueado ' + environment.userEmailLogged + ' no tiene acceso a la aplicación.');
      //this.msalService.logout();
      }
    );
  }
  openModal(data:any) {
      this.dialog.open(UpdateUserComponent, {
        minWidth: '100px',
        data:data
      }).afterClosed().subscribe(result => {
        this.getuser()
      });
    }

  obtenerUrlsNavbar() {
    this.activeRoute.queryParams.subscribe(params => {
      const paramsLogin = params['tipoUsuario'];
      if(paramsLogin === 'Marca') {
        this.navItems = navItemsDB;
      }else if( paramsLogin === 'ReporteMarca,Marca'){
        this.navItems = navItemsReporte;
      }
      else if(paramsLogin === 'MarcaCertificada')
      {
        this.navItems = navItemsCertificadaDB;
      }else if(paramsLogin === 'Marca,MarcaCertificada')
      {
        this.navItems = navItemsMixVentas;
      }else if(paramsLogin === 'ReporteMarca,Marca,MarcaCertificada')
      {
        this.navItems = navItemsMixVentas;
      }
      else if(paramsLogin === 'Pactia')
      {
        this.navItems = navItemsPactia;
      }
    });
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logOut() {
    if (sessionStorage.getItem("MarcaValido") === '1') {
      sessionStorage.removeItem("MarcaValido")
      sessionStorage.removeItem("userEmailLogged")
      this.router.navigate(['/login']);
    }else{
      this.msalService.logout();
    }
  }
  dashboard(url: string):boolean{
    return url === '/home/dashboard' || url === '/inicio/dashboard' || url.includes('?login')
  }
}
